import { cr } from "fire-wind-water";
import { skfIf } from "./if";
import { skfText } from "./text";
import { skfValue } from "./value";
import { SkfEvent } from "./event";
import { SkfProp } from "./property";
import { SkfClassName } from "./class";
import { skfHtml } from "./html";

class FieldBind {
  doms: any = {
    if: [],
  };

  $directive: any[] = [];
  $field: any;

  constructor(
    private elem: HTMLElement,
    private field: any,
    private $parent: any
  ) {
    this.skFieldIf();
    this.skFieldText();
    this.skFieldValue();
    this.skFieldEvent("skf-change");
    this.skFieldEvent("skf-click");
    this.skFieldEvent("skf-focus");
    this.skFieldProp("skf-disabled");
    this.skFieldProp("skf-checked");
    this.skFieldProp("skf-accept");
    this.skFieldProp("skf-src");
    this.skFieldHtml();
    this.skFieldClass();
    // this.$field = this.observerProxy(this.field);
    // this.$field.setValue('855555');
    this.field.sendCallback = () => {
      cr.each(this.$directive, (d) => {
        if (d.attr.indexOf("sendCodeJson") !== -1) {
          d.update();
        }
      });
    };
    this.field.uploadCallback = () => {
      // console.log(res)
      cr.each(this.$directive, (d) => {
        d.update();
      });
    };
    this.updateView();
    return this;
  }

  observerProxy(object): any {
    const handler: any = {
      set(target, key, value) {
        target[key] = value;
        return true;
      },
    };
    return new Proxy(object, handler);
  }

  updateView(): void {
    cr.each(this.$directive, (d) => {
      d.update();
    });
  }

  skFieldIf() {
    this.doms.if = this.elem.querySelectorAll("[skf-if]");
    cr.each(this.doms.if, (d) => {
      this.$directive.push(new skfIf(d, this.field));
    });
  }

  skFieldText(): void {
    this.doms.text = this.elem.querySelectorAll("[skf-text]");
    cr.each(this.doms.text, (d) => {
      this.$directive.push(new skfText(d, this.field));
    });
  }

  skFieldValue(): void {
    this.doms.value = this.elem.querySelectorAll("[skf-value]");
    cr.each(this.doms.value, (d) => {
      this.$directive.push(new skfValue(d, this.field));
    });
  }

  skFieldEvent(s): void {
    this.doms[s] = this.elem.querySelectorAll(`[${s}]`);
    cr.each(this.doms[s], (d) => {
      new SkfEvent(d, this, s);
    });
  }

  skFieldProp(s: string): void {
    this.doms[s] = this.elem.querySelectorAll(`[${s}]`);
    cr.each(this.doms[s], (d) => {
      this.$directive.push(new SkfProp(d, this.field, s.replace("skf-", "")));
    });
  }

  skFieldClass(): void {
    this.doms.class = this.elem.querySelectorAll("[skf-class]");
    cr.each(this.doms.class, (d) => {
      this.$directive.push(new SkfClassName(d, this.field));
    });
  }

  skFieldHtml(): void {
    this.doms.html = this.elem.querySelectorAll("[skf-html]");
    cr.each(this.doms.html, (d) => {
      this.$directive.push(new skfHtml(d, this.field));
    });
  }
}

export { FieldBind };
